const NorthernIrelandRegionsIds = [
  'N09000001',
  'N09000002',
  'N09000003',
  'N09000004',
  'N09000005',
  'N09000006',
  'N09000007',
  'N09000008',
  'N09000009',
  'N09000010',
  'N09000011'
]

export const UnitedKingdomRegionsIds = {
  Scotland: 'S15000001',
  'North East': 'E15000001',
  'North West': 'E15000002',
  'Yorkshire and The Humber': 'E15000003',
  'East Midlands': 'E15000004',
  'West Midlands': 'E15000005',
  'East of England': 'E15000006',
  London: 'E15000007',
  'South East': 'E15000008',
  'South West': 'E15000009',
  Wales: 'W08000001',
  // For Northern Ireland we have multiple regions, but we need to consider them as a single region
  'Northern Ireland': NorthernIrelandRegionsIds
}

export const UnitedKingdomRegions = Object.keys(UnitedKingdomRegionsIds).map(key => ({
  value: key,
  label: key
}))
